(function () {
  const topSection = () => document.querySelector('.shop-by-brand-top-section');
  const getHeights = () => {
    const header = document.querySelector('.site-header');
    const section = topSection();
    return {
      header: (header?.offsetHeight ?? 0) - 1,
      alphabetTop: section?.offsetHeight ?? 0,
    };
  };

  const updateStickyTop = () => {
    const section = topSection();
    const sectionHeader = document.querySelector('.section-header');
    if (section) {
      section.style.top = sectionHeader?.classList.contains('header-hidden') ? '0px' : getHeights().header + 'px';
    }
  };

  const scrollToTarget = (target) => {
    if (!target) return;
    const { header, alphabetTop } = getHeights();
    const pos = target.getBoundingClientRect().top + window.scrollY - (header + alphabetTop);
    window.scrollTo({ top: pos, behavior: 'smooth' });
  };

  let scrollTicking = false;
  let lastActiveLetter = '';
  let scrollHandlerRef = null;
  let buttonsInit = false;

  const init = () => {
    const section = topSection();
    const buttons = document.querySelectorAll('.shop-by-brand-listing-li');
    const sections = document.querySelectorAll('.shop-by-brand-alphabet-block');
    if (!section || !buttons.length) return;

    const { header, alphabetTop } = getHeights();
    section.style.top = header + 'px';

    buttons.forEach((button) => {
      const targetId = button.getAttribute('data-target');
      if (!document.querySelector(targetId)) {
        button.style.opacity = '0.5';
        button.style.pointerEvents = 'none';
      }
    });

    if (!buttonsInit) {
      buttonsInit = true;
      const wrapper = document.querySelector('.shop-by-brand-alphabet-wrapper');
      if (wrapper) {
        wrapper.addEventListener('click', (e) => {
          const btn = e.target.closest('.shop-by-brand-listing-li');
          if (btn) scrollToTarget(document.querySelector(btn.getAttribute('data-target')));
        });
        wrapper.addEventListener('keydown', (e) => {
          if (e.key !== 'Enter' && e.key !== ' ') return;
          const btn = e.target.closest('.shop-by-brand-listing-li');
          if (btn) {
            e.preventDefault();
            scrollToTarget(document.querySelector(btn.getAttribute('data-target')));
          }
        });
      }
    }

    const onScroll = () => {
      if (scrollTicking) return;
      scrollTicking = true;
      requestAnimationFrame(() => {
        const { header, alphabetTop } = getHeights();
        const threshold = alphabetTop + header + 30;
        updateStickyTop();

        let current = '';
        sections.forEach((s) => {
          const top = s.getBoundingClientRect().top + window.scrollY;
          const bottom = top + s.clientHeight;
          if (window.scrollY >= top - threshold && window.scrollY < bottom - threshold) current = s.id;
        });

        buttons.forEach((button) => {
          const isActive = button.getAttribute('data-target') === `#${current}`;
          button.classList.toggle('active', isActive);
          if (isActive && lastActiveLetter !== current) {
            lastActiveLetter = current;
            button.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
          }
        });
        lastActiveLetter = current || '';
        scrollTicking = false;
      });
    };

    if (scrollHandlerRef) window.removeEventListener('scroll', scrollHandlerRef);
    scrollHandlerRef = onScroll;
    window.addEventListener('scroll', onScroll);
    onScroll();
  };

  document.addEventListener('DOMContentLoaded', init);
  window.addEventListener('resize', init);
})();
